import React from 'react';

const VerticalDivider = () => (
    <div className="divider-vertical"></div>
);

export default VerticalDivider;
